/* eslint-disable consistent-return */
import { all, fork, takeEvery,call, put } from 'redux-saga/effects';

import { getDataSuccess } from "./action";

const DUMMY_GET_DATA = "DUMMY_GET_DATA"


// import getData from "./action";

const getDummyData = async () => {
  try {
    
    const res = await fetch('https://jsonplaceholder.typicode.com/users')
    const result = await res.json()
    return result
  } catch (error) {
    console.log(error)
  }
}

function* getDummyList() {
  try {
    const res = yield call(getDummyData)
    yield put(getDataSuccess(res))
  } catch (error) {
    console.log(error)
  }
}

export function* watchGetList() {
  yield takeEvery(DUMMY_GET_DATA,getDummyList)
}

export default function* rootSaga(){
  yield all([fork(watchGetList)])
}